import * as React from "react";
import {useState} from "react";
import {useSearchParams} from "react-router-dom";
import BoothOverlay from "../BoothOverlay/BoothOverlay";
import ExhibitorBoothPopup from "./ExhibitorBoothPopup/ExhibitorBoothPopup";
import {getRequest} from "../../../../Helper/ApiClient";
import RobotPopup from "./RobotPopup/RobotPopup";
import { RandomProductResponse } from "../../../../../Interface/Vts";

export default function ShowBooth() {
    const [booth, setBooth] = useState<string|null>(null);
    const legacyUi = useLegacyBoothUi();

    const randomProductRequest = getRequest<RandomProductResponse | null>(
      '/api/recommended-top-product', undefined, { enabled: false }
    );

    // @ts-ignore
    window.showBooth = (booth) => {
        // console.log(booth);
        if (booth === 'robot') {
          randomProductRequest.refetch();
        }
        setBooth(booth.toString());
    };

    if(!booth) {
        return null;
    }

    return (
      <>
        {booth === 'robot' ? (
          <>
          {randomProductRequest.isSuccess && !randomProductRequest.isFetching && (
            <RobotPopup randomProduct={randomProductRequest.data} onClose={() => setBooth(null)} />
          )}
          </>
        ) : legacyUi ? (
          <ExhibitorBoothPopup
            key={booth}
            boothNumber={parseInt(booth)}
            onClose={() => {
              setBooth(null);
            }}
          />
        ) : (
          <BoothOverlay
            key={booth}
            boothNumber={parseInt(booth)}
            onClose={() => {
              setBooth(null);
            }}
          />
        )}
      </>
    );
}

const BOOTH_UI_STORAGE_KEY = 'vts_booth_ui';

/**
 * Comparison switch while the brand booth overlay (P-4889) is under review: `?booth_ui=legacy` opens
 * the old ExhibitorPopup instead of the BoothOverlay, `?booth_ui=overlay` switches back. The choice
 * sticks for the browser tab because krpano navigation drops the query string.
 */
function useLegacyBoothUi(): boolean {
    const [searchParams] = useSearchParams();
    const requested = searchParams.get('booth_ui');
    try {
        if (requested === 'legacy') {
            sessionStorage.setItem(BOOTH_UI_STORAGE_KEY, 'legacy');
        } else if (requested === 'overlay') {
            sessionStorage.removeItem(BOOTH_UI_STORAGE_KEY);
        }
        return sessionStorage.getItem(BOOTH_UI_STORAGE_KEY) === 'legacy';
    } catch {
        return requested === 'legacy';
    }
}
